
























import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class OkModal extends Vue {
  @Prop({ default: "確認" }) pTitle!: string;
  @Prop({ default: "同意しますか?" }) pMessage!: string;
  @Prop({ default: "" }) subMessage!: string;
  @Prop({ default: "OK" }) pOkMessage!: string;
  @Prop({ default: false }) pFunction!: boolean;

  dialog = false;

  open() {
    this.dialog = true;
  }

  cancel() {
    this.dialog = false;
  }

  ok() {
    this.dialog = false;
    if (this.pFunction) {
      this.$emit("ok");
    }
  }
}
